import { BlobProvider } from '@react-pdf/renderer';
import * as React from 'react';
import {getUserActivityReportPdfExport} from './pdfExport';

interface IProps {
  currentMonth: string
  previousMonth: string
  tableData: any
}

export const ExportComponent = (props: IProps) => {
  const data = props;
  return (
    <div style={{float: 'right', padding: '10px'}}>
      <BlobProvider
        document={getUserActivityReportPdfExport(data)}
      >
        {({url, loading}) => {
          if (!loading) {
            return <a href={url} target="_blank"><img className="link" src="images/pdf_32.png" alt="pdf icon"/></a>
          } else {
            return <span>Preparing PDF</span>
          }
        }}
      </BlobProvider>
    </div>
  );
};
